import { useState, useRef } from 'react';

const FORM_URL = 'https://readdy.ai/api/form/d70ka44ciedc9e24me80';

function LeadForm({ id }: { id: string }) {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const formRef = useRef<HTMLFormElement>(null);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const form = e.currentTarget;
    const data = new URLSearchParams();
    const elements = form.elements as HTMLFormControlsCollection;
    for (let i = 0; i < elements.length; i++) {
      const el = elements[i] as HTMLInputElement | HTMLTextAreaElement;
      if (el.name) data.append(el.name, el.value);
    }
    try {
      const res = await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
      });
      if (res.ok) {
        setSubmitted(true);
      } else {
        setError('Er ging iets mis. Probeer het opnieuw.');
      }
    } catch {
      setError('Er ging iets mis. Probeer het opnieuw.');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="text-center py-10 px-6">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <i className="ri-check-line text-3xl text-green-600"></i>
        </div>
        <h3 className="text-xl font-bold text-gray-900 mb-2" style={{ fontFamily: '"Poppins", sans-serif' }}>
          Aanvraag ontvangen!
        </h3>
        <p className="text-gray-600" style={{ fontFamily: '"Inter", sans-serif' }}>
          We nemen binnen 24 uur contact met je op. Je betaalt pas na oplevering.
        </p>
      </div>
    );
  }

  return (
    <form
      id={id}
      ref={formRef}
      data-readdy-form
      onSubmit={handleSubmit}
      className="space-y-4"
    >
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1" style={{ fontFamily: '"Inter", sans-serif' }}>
            Voornaam <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="voornaam"
            required
            placeholder="Jan"
            className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-[#F57C00] focus:border-transparent transition"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1" style={{ fontFamily: '"Inter", sans-serif' }}>
            Achternaam <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="achternaam"
            required
            placeholder="Bakker"
            className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-[#F57C00] focus:border-transparent transition"
          />
        </div>
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1" style={{ fontFamily: '"Inter", sans-serif' }}>
          Bedrijfsnaam <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          name="bedrijfsnaam"
          required
          placeholder="Jouw bedrijf"
          className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-[#F57C00] focus:border-transparent transition"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1" style={{ fontFamily: '"Inter", sans-serif' }}>
          E-mailadres <span className="text-red-500">*</span>
        </label>
        <input
          type="email"
          name="email"
          required
          placeholder="jan@bedrijf.nl"
          className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-[#F57C00] focus:border-transparent transition"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1" style={{ fontFamily: '"Inter", sans-serif' }}>
          Telefoonnummer <span className="text-red-500">*</span>
        </label>
        <input
          type="tel"
          name="telefoonnummer"
          required
          placeholder="06 12345678"
          className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-[#F57C00] focus:border-transparent transition"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1" style={{ fontFamily: '"Inter", sans-serif' }}>
          Wat doe je? (korte omschrijving)
        </label>
        <textarea
          name="beschrijving"
          rows={3}
          maxLength={500}
          placeholder="Bijv: Ik ben schilder en zoek een eenvoudige website om meer klanten te krijgen."
          className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-[#F57C00] focus:border-transparent transition resize-none"
        />
      </div>
      {error && (
        <p className="text-red-500 text-sm">{error}</p>
      )}
      <button
        type="submit"
        disabled={loading}
        className="w-full bg-[#F57C00] text-white py-4 rounded-lg font-bold text-lg hover:bg-[#E65100] transition-colors whitespace-nowrap cursor-pointer disabled:opacity-70 disabled:cursor-not-allowed"
        style={{ fontFamily: '"Poppins", sans-serif' }}
      >
        {loading ? 'Bezig met verzenden...' : 'Vraag offerte aan'}
      </button>
      <p className="flex items-center justify-center gap-1.5 text-sm text-gray-500 font-medium mt-1.5" style={{ fontFamily: '"Inter", sans-serif' }}>
        <span className="w-4 h-4 flex items-center justify-center text-green-500">
          <i className="ri-checkbox-circle-fill text-base"></i>
        </span>
        Gratis &amp; vrijblijvend
      </p>
    </form>
  );
}

export default function VraagGratisAanbod() {
  const formSectionRef = useRef<HTMLDivElement>(null);

  const scrollToForm = () => {
    formSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const steps = [
    { number: '01', title: 'Jij vult het formulier in', desc: 'Duurt minder dan 2 minuten.' },
    { number: '02', title: 'Wij nemen contact op', desc: 'Binnen 24 uur bellen of mailen we je.' },
    { number: '03', title: 'Wij bouwen jouw website', desc: 'Professioneel en op maat gemaakt.' },
    { number: '04', title: 'Jij geeft feedback', desc: 'Onbeperkt aanpassingen tot je tevreden bent.' },
    { number: '05', title: 'Website gaat live', desc: 'Klaar voor klanten en Google.' },
    { number: '06', title: 'Jij betaalt daarna', desc: 'Pas als jij blij bent.' },
  ];

  const includes = [
    { icon: 'ri-pages-line', text: 'Homepage (uitleg van jouw dienst/product)' },
    { icon: 'ri-user-heart-line', text: 'Over ons pagina' },
    { icon: 'ri-mail-line', text: 'Contact pagina' },
    { icon: 'ri-whatsapp-line', text: 'WhatsApp knop op je website' },
    { icon: 'ri-server-line', text: '1 jaar hosting' },
    { icon: 'ri-global-line', text: '1 jaar domein' },
    { icon: 'ri-customer-service-line', text: '1 jaar support' },
    { icon: 'ri-refresh-line', text: 'Onbeperkte aanpassingen' },
  ];

  const trustItems = [
    { icon: 'ri-secure-payment-line', title: 'Betaal achteraf', desc: 'Je betaalt pas als de website live is en jij tevreden bent.' },
    { icon: 'ri-shield-check-line', title: 'Geen verplichtingen', desc: 'Geen contract. Geen kleine lettertjes. Geen gedoe.' },
    { icon: 'ri-team-line', title: 'Gericht op ZZP & MKB', desc: 'We kennen jouw uitdagingen en spreken jouw taal.' },
    { icon: 'ri-time-line', title: 'Snel live', desc: 'Gemiddeld binnen 5 werkdagen staat jouw website online.' },
  ];

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: '"Inter", sans-serif' }}>
      {/* Minimal Header */}
      <header className="bg-white border-b border-gray-100 py-4 px-6">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          <a href="/" className="text-2xl font-bold text-[#F57C00]" style={{ fontFamily: '"Poppins", sans-serif' }}>
            StarSales
          </a>
          <a
            href="tel:097010224137"
            className="flex items-center gap-2 text-gray-700 hover:text-[#F57C00] transition-colors text-sm font-medium"
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-phone-line text-base"></i>
            </div>
            0970 102 241 37
          </a>
        </div>
      </header>

      {/* HERO + FORM */}
      <section className="bg-gradient-to-br from-gray-950 via-gray-900 to-gray-800 text-white relative overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/9322d1516bff60fa48698b223e742429.jpg"
            alt="Achtergrond"
            className="w-full h-full object-cover object-top opacity-20"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-gray-950/80 via-gray-900/70 to-gray-800/80"></div>
        </div>
        <div className="relative max-w-6xl mx-auto px-4 py-16 lg:py-24">
          <div className="grid lg:grid-cols-2 gap-12 items-start">
            {/* Left: Headline */}
            <div className="w-full">
              <div className="inline-flex items-center gap-2 bg-[#F57C00]/20 border border-[#F57C00]/40 text-[#F57C00] text-sm font-medium px-4 py-2 rounded-full mb-6">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-flashlight-line text-sm"></i>
                </div>
                Speciaal aanbod voor ZZP & MKB
              </div>
              <h1 className="text-3xl md:text-5xl font-bold leading-tight mb-6" style={{ fontFamily: '"Poppins", sans-serif' }}>
                Professionele website voor{' '}
                <span className="text-[#F57C00]">€249</span>
                <br />
                <span className="text-2xl md:text-3xl text-gray-300 font-normal">(betaal pas achteraf)</span>
              </h1>
              <p className="text-lg text-gray-300 mb-8 leading-relaxed">
                Voor zzp'ers en kleine bedrijven die snel en zonder risico online willen. Geen gedoe, geen risico — jij betaalt pas als je tevreden bent.
              </p>
              <ul className="space-y-3 mb-10">
                {[
                  'Complete website (home + over ons + contact)',
                  '1 jaar hosting + domein inbegrepen',
                  'Onbeperkte revisies tot je tevreden bent',
                  'Support altijd inbegrepen',
                  'WhatsApp knop op je website',
                ].map((item, i) => (
                  <li key={i} className="flex items-center gap-3 text-gray-200">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                      <i className="ri-checkbox-circle-fill text-[#F57C00] text-lg"></i>
                    </div>
                    {item}
                  </li>
                ))}
              </ul>
              <button
                onClick={scrollToForm}
                className="lg:hidden w-full bg-[#F57C00] text-white py-4 rounded-lg font-bold text-lg hover:bg-[#E65100] transition-colors whitespace-nowrap cursor-pointer"
                style={{ fontFamily: '"Poppins", sans-serif' }}
              >
                Vraag nu jouw website aan
              </button>
              {/* Social Proof */}
              <div className="mt-8 flex items-center gap-4">
                <div className="flex -space-x-2">
                  {['lp-av1', 'lp-av2', 'lp-av3'].map((seq, i) => (
                    <img
                      key={i}
                      src={`https://readdy.ai/api/search-image?query=Professional%20Dutch%20business%20owner%20friendly%20portrait%2C%20headshot%2C%20clean%20background%2C%20natural%20smile%2C%20business%20casual%2C%20high%20quality&width=40&height=40&seq=${seq}&orientation=squarish`}
                      alt="Klant"
                      className="w-10 h-10 rounded-full border-2 border-gray-800 object-cover"
                    />
                  ))}
                </div>
                <div className="text-sm text-gray-300">
                  <span className="text-white font-semibold">50+ ondernemers</span> gingen je voor
                </div>
              </div>
            </div>

            {/* Right: Form */}
            <div ref={formSectionRef} className="w-full" id="form-hero">
              <div className="bg-white rounded-2xl p-6 md:p-8">
                <h2 className="text-xl font-bold text-gray-900 mb-1" style={{ fontFamily: '"Poppins", sans-serif' }}>
                  Vraag jouw website aan
                </h2>
                <p className="text-sm text-gray-500 mb-6">Gratis adviesgesprek. Geen verplichtingen.</p>
                <LeadForm id="hero-form" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PROBLEEM */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-3xl mx-auto px-4 text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6" style={{ fontFamily: '"Poppins", sans-serif' }}>
            Herken je dit?
          </h2>
          <div className="grid md:grid-cols-3 gap-6 text-left mb-8">
            {[
              { icon: 'ri-close-circle-line', text: 'Je hebt nog geen website en potentiële klanten vinden je niet' },
              { icon: 'ri-close-circle-line', text: 'Je website ziet er verouderd uit en levert geen klanten op' },
              { icon: 'ri-close-circle-line', text: 'Je betaalt te veel voor een website die niks doet' },
            ].map((item, i) => (
              <div key={i} className="bg-white rounded-xl p-5 border border-red-100">
                <div className="w-8 h-8 flex items-center justify-center mb-3">
                  <i className={`${item.icon} text-red-400 text-2xl`}></i>
                </div>
                <p className="text-gray-700 text-sm leading-relaxed">{item.text}</p>
              </div>
            ))}
          </div>
          <p className="text-gray-600 text-lg">
            Een goede website hoeft niet duur of ingewikkeld te zijn. <strong className="text-gray-900">Wij regelen het voor je.</strong>
          </p>
        </div>
      </section>

      {/* OPLOSSING */}
      <section className="py-16 bg-white">
        <div className="max-w-5xl mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="w-full">
              <div className="w-full h-72 rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20professional%20website%20displayed%20on%20laptop%20and%20smartphone%20mockup%2C%20clean%20minimal%20design%20showing%20a%20Dutch%20small%20business%20website%2C%20premium%20quality%20website%20preview%2C%20professional%20web%20design%2C%20white%20and%20orange%20color%20scheme%2C%20clear%20typography%2C%20high%20quality%20product%20mockup%20photography&width=600&height=450&seq=lp-solution-1&orientation=landscape"
                  alt="Website voorbeeld"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
            <div className="w-full">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Poppins", sans-serif' }}>
                Wij bouwen jouw website van A tot Z
              </h2>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Geen gedoe. Geen risico. Jij levert alleen een korte omschrijving van je bedrijf — wij doen de rest. En het mooiste?
              </p>
              <div className="bg-[#F57C00]/10 border-l-4 border-[#F57C00] rounded-r-xl p-5 mb-6">
                <p className="text-gray-900 font-semibold text-lg" style={{ fontFamily: '"Poppins", sans-serif' }}>
                  👉 Jij betaalt pas als je tevreden bent.
                </p>
              </div>
              <ul className="space-y-3">
                {[
                  'Professioneel ontwerp op maat',
                  'Gevonden worden op Google',
                  'Werkt perfect op mobiel',
                  'Klaar in gemiddeld 5 werkdagen',
                ].map((item, i) => (
                  <li key={i} className="flex items-center gap-3 text-gray-700">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-[#F57C00] text-lg"></i>
                    </div>
                    {item}
                  </li>
                ))}
              </ul>
              <button
                onClick={scrollToForm}
                className="mt-8 bg-[#F57C00] text-white px-8 py-4 rounded-lg font-bold hover:bg-[#E65100] transition-colors whitespace-nowrap cursor-pointer"
                style={{ fontFamily: '"Poppins", sans-serif' }}
              >
                Ja, ik wil dit!
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* AANBOD */}
      <section className="py-16 bg-gray-950 text-white">
        <div className="max-w-4xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-bold mb-3" style={{ fontFamily: '"Poppins", sans-serif' }}>
              Alles inbegrepen voor{' '}
              <span className="text-[#F57C00]">€249</span>
            </h2>
            <p className="text-gray-400">Geen verborgen kosten. Wat je ziet, is wat je krijgt.</p>
          </div>
          <div className="grid md:grid-cols-2 gap-4 mb-10">
            {includes.map((item, i) => (
              <div key={i} className="flex items-center gap-4 bg-gray-800 rounded-xl px-5 py-4">
                <div className="w-10 h-10 bg-[#F57C00]/20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className={`${item.icon} text-[#F57C00] text-xl`}></i>
                </div>
                <span className="text-gray-200 text-sm">{item.text}</span>
              </div>
            ))}
          </div>
          <div className="bg-[#F57C00] rounded-2xl p-6 flex flex-col md:flex-row items-center justify-between gap-4">
            <div>
              <p className="font-bold text-xl" style={{ fontFamily: '"Poppins", sans-serif' }}>
                Totaal: €249 — betaal achteraf
              </p>
              <p className="text-white/80 text-sm">Je betaalt pas nadat je website live gaat en jij tevreden bent.</p>
            </div>
            <button
              onClick={scrollToForm}
              className="bg-white text-[#F57C00] px-8 py-3 rounded-lg font-bold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer flex-shrink-0"
              style={{ fontFamily: '"Poppins", sans-serif' }}
            >
              Nu aanvragen
            </button>
          </div>
        </div>
      </section>

      {/* HOE HET WERKT */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900" style={{ fontFamily: '"Poppins", sans-serif' }}>
              Hoe het werkt
            </h2>
            <p className="text-gray-500 mt-2">In 6 eenvoudige stappen naar jouw website</p>
          </div>
          <div className="grid md:grid-cols-2 gap-4">
            {steps.map((step, i) => (
              <div key={i} className="flex items-start gap-4 bg-gray-50 rounded-xl p-5">
                <div className="w-12 h-12 bg-gray-900 text-white rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0" style={{ fontFamily: '"Poppins", sans-serif' }}>
                  {step.number}
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1" style={{ fontFamily: '"Poppins", sans-serif' }}>
                    {step.title}
                  </h3>
                  <p className="text-gray-600 text-sm">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TRUST */}
      <section className="py-16 bg-[#F57C00]/5 border-y border-[#F57C00]/10">
        <div className="max-w-5xl mx-auto px-4">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900" style={{ fontFamily: '"Poppins", sans-serif' }}>
              Waarom ondernemers ons vertrouwen
            </h2>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {trustItems.map((item, i) => (
              <div key={i} className="bg-white rounded-xl p-6 text-center border border-gray-100">
                <div className="w-12 h-12 bg-[#F57C00]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${item.icon} text-[#F57C00] text-2xl`}></i>
                </div>
                <h3 className="font-bold text-gray-900 mb-2 text-sm" style={{ fontFamily: '"Poppins", sans-serif' }}>
                  {item.title}
                </h3>
                <p className="text-gray-600 text-xs leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* RESULTAAT */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Poppins", sans-serif' }}>
            Wat jouw website voor jou doet
          </h2>
          <p className="text-gray-600 mb-10">Een goede website is meer dan een visitekaartje. Het is je beste verkoper.</p>
          <div className="grid md:grid-cols-3 gap-6 mb-10">
            {[
              { icon: 'ri-star-line', title: 'Professioneel oogt', desc: 'Klanten zien direct dat jij serieus bent. Eerste indruk telt.' },
              { icon: 'ri-shield-user-line', title: 'Vertrouwen geeft', desc: 'Bezoekers voelen zich veilig om contact op te nemen.' },
              { icon: 'ri-line-chart-line', title: 'Klanten oplevert', desc: 'Gevonden worden op Google en meer aanvragen binnenkrijgen.' },
            ].map((item, i) => (
              <div key={i} className="bg-gray-50 rounded-xl p-6 border border-gray-100">
                <div className="w-12 h-12 bg-gray-900 text-white rounded-xl flex items-center justify-center mx-auto mb-4">
                  <i className={`${item.icon} text-xl`}></i>
                </div>
                <h3 className="font-bold text-gray-900 mb-2" style={{ fontFamily: '"Poppins", sans-serif' }}>
                  {item.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* REVIEWS */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-5xl mx-auto px-4">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900" style={{ fontFamily: '"Poppins", sans-serif' }}>
              Wat onze klanten zeggen
            </h2>
          </div>
          <div className="grid md:grid-cols-3 gap-6">
            {[
              {
                name: 'Joost van Dijk',
                role: 'Loodgieter, ZZP',
                text: 'Binnen een week had ik een prachtige website. En inderdaad: ik betaalde pas nadat alles goed stond. Top service!',
                seq: 'lp-rev1',
              },
              {
                name: 'Marieke de Boer',
                role: 'Schoonheidsspecialiste, MKB',
                text: 'Eindelijk een website die er echt professioneel uitziet. Al 3 nieuwe klanten via de website in de eerste maand.',
                seq: 'lp-rev2',
              },
              {
                name: 'Sander Visser',
                role: 'Aannemer, ZZP',
                text: 'Super fijn team. Ze denken mee, zijn snel en de prijs is belachelijk eerlijk. Betalen achteraf is echt een groot voordeel.',
                seq: 'lp-rev3',
              },
            ].map((review, i) => (
              <div key={i} className="bg-white rounded-xl p-6 border border-gray-100">
                <div className="flex items-center mb-3">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <i key={s} className="ri-star-fill text-[#F57C00] text-sm"></i>
                  ))}
                </div>
                <p className="text-gray-700 text-sm leading-relaxed italic mb-5">"{review.text}"</p>
                <div className="flex items-center gap-3">
                  <img
                    src={`https://readdy.ai/api/search-image?query=Dutch%20professional%20small%20business%20owner%20friendly%20headshot%20portrait%2C%20natural%20light%2C%20business%20casual%20clothing%2C%20genuine%20smile%2C%20clean%20neutral%20background%2C%20high%20quality%20photography&width=48&height=48&seq=${review.seq}&orientation=squarish`}
                    alt={review.name}
                    className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                  />
                  <div>
                    <p className="font-semibold text-gray-900 text-sm">{review.name}</p>
                    <p className="text-gray-500 text-xs">{review.role}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA BOTTOM + FORM REPEAT */}
      <section className="py-16 bg-gray-900 text-white">
        <div className="max-w-5xl mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="w-full">
              <h2 className="text-2xl md:text-4xl font-bold mb-4" style={{ fontFamily: '"Poppins", sans-serif' }}>
                Klaar om jouw website te laten maken?
              </h2>
              <p className="text-gray-400 mb-6 leading-relaxed">
                Vul het formulier in. Wij nemen binnen 24 uur contact op. Jij betaalt pas achteraf.
              </p>
              <ul className="space-y-3">
                {[
                  'Betaal achteraf — geen risico',
                  'Onbeperkte revisies',
                  'Geen verborgen kosten',
                  'Support altijd inbegrepen',
                ].map((item, i) => (
                  <li key={i} className="flex items-center gap-3 text-gray-300 text-sm">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                      <i className="ri-checkbox-circle-fill text-[#F57C00] text-lg"></i>
                    </div>
                    {item}
                  </li>
                ))}
              </ul>
              <div className="mt-8 pt-8 border-t border-gray-700">
                <p className="text-gray-500 text-sm mb-2">Liever direct bellen?</p>
                <a
                  href="tel:097010224137"
                  className="flex items-center gap-2 text-white font-semibold text-lg hover:text-[#F57C00] transition-colors"
                >
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-phone-fill text-[#F57C00]"></i>
                  </div>
                  0970 102 241 37
                </a>
              </div>
            </div>
            <div className="w-full">
              <div className="bg-white rounded-2xl p-6 md:p-8">
                <h3 className="text-xl font-bold text-gray-900 mb-1" style={{ fontFamily: '"Poppins", sans-serif' }}>
                  Vraag jouw website aan
                </h3>
                <p className="text-sm text-gray-500 mb-6">Kosteloos. Zonder verplichting.</p>
                <LeadForm id="bottom-form" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-950 text-gray-500 py-8">
        <div className="max-w-5xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm">© 2025 StarSales B.V. — KvK: 97377562 — Volendam</p>
          <div className="flex items-center gap-6 text-sm">
            <a href="/privacy" className="hover:text-white transition-colors">Privacy</a>
            <a href="/voorwaarden" className="hover:text-white transition-colors">Voorwaarden</a>
            <a href="/cookies" className="hover:text-white transition-colors">Cookies</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
